import React, { useState, useEffect } from 'react';
import {KatRow, KatColumn, KatDataTable, KatInput, KatPagination} from '@amzn/katal-react';
import { TELLER_TESTS_HEADER } from 'src/components/constants/dataTableHeaders';
import { TestCase } from 'src/components/types/TestCase';
import { fetchTestCases } from 'src/components/helper/testCaseDataHelper';
import './css/TestCaseData.css';

const TestCaseData: React.FC = () => {
    const [testCases, setTestCases] = useState<TestCase[]>([]);
    const [filteredTestCases, setFilteredTestCases] = useState<TestCase[]>([]);
    const [searchTerm, setSearchTerm] = useState('');

    const [testcaseCurrentPage, setTestcaseCurrentPage] = useState(1);
    const [testcaseItemsPerPage, setTestcaseItemsPerPage] = useState(10);

    const handleSearchChange = (term: string) => {
        setSearchTerm(term);
        const lowerTerm = term.trim().toLowerCase();

        if (lowerTerm === '') {
            setFilteredTestCases(testCases);
            return;
        }

        const matchesSearch = (value: any) => {
            if (typeof value !== 'string' && typeof value !== 'number') return false;
            return String(value).toLowerCase().includes(lowerTerm);
        };

        const filtered = testCases.filter((test) =>
            Object.values(test).some((val) => matchesSearch(val))
        );

        setFilteredTestCases(filtered);
    };

    useEffect(() => {
        const loadTestCases = async () => {
            const cases = await fetchTestCases('Teller', false);
            setTestCases(cases);
        };
        loadTestCases();
    }, []);

    useEffect(() => {
        handleSearchChange(searchTerm);
    }, [testCases]);

    const paginatedTestCases = filteredTestCases.slice(
        (testcaseCurrentPage - 1) * testcaseItemsPerPage,
        testcaseCurrentPage * testcaseItemsPerPage
    );

    return (
        <div className="test-case-section">
            {/* Optional Section Title */}
            <h4 style={{ marginBottom: '16px' }}>Available Teller Test Cases</h4>

            {/* Search Input */}
            <KatRow>
                <KatColumn xs={12}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <KatInput
                            type="search"
                            placeholder="Search..."
                            value={searchTerm}
                            onInput={(e: KatInput.ChangeEvent) => handleSearchChange(e.currentTarget.value)}
                            size="small"
                        />
                    </div>
                </KatColumn>
            </KatRow>

            {/* Table */}
            <KatRow>
                <KatColumn xs={12}>
                    <KatDataTable
                        columns={TELLER_TESTS_HEADER}
                        rowData={paginatedTestCases}
                    />
                    <KatPagination
                        page={testcaseCurrentPage}
                        totalItems={filteredTestCases.length}
                        itemsPerPage={testcaseItemsPerPage}
                        variant="footer"
                        onChange={(e) => setTestcaseCurrentPage(e.detail.page)}
                        onItemsPerPageChange={(e) => {
                            setTestcaseItemsPerPage(e.detail.value);
                            setTestcaseCurrentPage(1); // Reset to first page when changing page size
                        }}
                    />
                </KatColumn>
            </KatRow>
        </div>
    );
};

export default TestCaseData;
